import { useEffect, useCallback } from "react";
import { useTheme } from "next-themes";

const THEME_USER_SET_KEY = "theme-user-set";

export function useResponsiveTheme(): void {
  const { setTheme } = useTheme();

  const applyDefault = useCallback(() => {
    const userHasChosen = localStorage.getItem(THEME_USER_SET_KEY);
    if (!userHasChosen) {
      setTheme("light");
    }
  }, [setTheme]);

  useEffect(() => {
    applyDefault();

    const mql = window.matchMedia("(max-width: 767px)");
    const handler = () => applyDefault();
    mql.addEventListener("change", handler);
    return () => { mql.removeEventListener("change", handler); };
  }, [applyDefault]);
}

/** Call this when the user manually toggles the theme */
export function setUserThemePreference(theme: string): void {
  localStorage.setItem(THEME_USER_SET_KEY, "true");
}

/** Reset to responsive default (e.g. on logout) */
export function clearUserThemePreference(): void {
  localStorage.removeItem(THEME_USER_SET_KEY);
}
